module.exports = __webpack_public_path__ + "allergiatunnus_fi_4vari-e18ad66012e873a17c1ef91dd6d11820.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/allergiatunnus_fi_4vari.png
// module id = 78
// module chunks = 0